import React, { useState } from 'react';
import { createCtx } from 'src/context/ContextUtils';

type ContextDataSmallType = {
  badgeCountPayment: number;
  setBadgeCountPayment: React.Dispatch<React.SetStateAction<number>>;
};

type DataSmallProviderProps = {
  children: React.ReactNode;
};

export const [useDataSmall, ContextDataSmallProvider] =
  createCtx<ContextDataSmallType>();

export const DataSmallProvider = (props: DataSmallProviderProps) => {
  const [badgeCountPayment, setBadgeCountPayment] = useState(0);

  return (
    <>
      <ContextDataSmallProvider
        value={{
          badgeCountPayment,
          setBadgeCountPayment,
        }}
      >
        {props.children}
      </ContextDataSmallProvider>
    </>
  );
};
